
<div class="follow-campaign">
  <app-fb-share [count]="sharedCounts?.fb" class="fbshare" [fundraiser]="fundraiser" [position]="11"></app-fb-share>
  <app-whatsapp-share [count]="sharedCounts" [basicInfo]="basicinfo" [isFundraiserEnded]="isFundraiserEnded" [position]="isMobile ? 12 : 11"></app-whatsapp-share>
  <app-follow-campaign [fundraiser]="fundraiser" [isFollowed]="fundraiser?.user_followed?.status"></app-follow-campaign>
</div>